import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

// Check if we're in development mode
const isDev = process.env.NODE_ENV === 'development';

i18n
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        // Default language - ENGLISH
        lng: 'en',
        fallbackLng: 'en',
        supportedLngs: ['en', 'vi'],

        // Single namespace: common
        ns: ['common'],
        defaultNS: 'common',

        // Backend config - load from public/locales
        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json',
        },

        // Detection config - only use localStorage
        detection: {
            order: ['localStorage'],
            caches: ['localStorage'],
            lookupLocalStorage: 'i18nextLng',
        },

        // CRITICAL: Prevent raw keys from ever appearing in UI
        returnNull: false,
        returnEmptyString: false,

        // Show "—" for missing keys instead of raw key
        parseMissingKeyHandler: (key: string) => {
            if (isDev) {
                console.warn(`[i18n] Missing translation key: "${key}"`);
            }
            return '—';
        },

        // Log missing keys in development
        saveMissing: isDev,
        missingKeyHandler: (lngs, ns, key, fallbackValue) => {
            if (isDev) {
                console.warn(`[i18n] Missing key: "${key}" in namespace "${ns}" for languages: ${lngs?.join(', ')}`);
            }
        },

        // Interpolation settings
        interpolation: {
            escapeValue: false,
        },

        // React settings
        react: {
            useSuspense: false,
        },

        // Debug mode in development only
        debug: isDev,
    });

export default i18n;
